
import { graphConfig } from "./authconfig";

/**
 * Attaches a given access token to a MS Graph API call. Returns information about the user
 * @param accessToken 
 */
export async function callMsGraph(accessToken) {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options = {
        method: "GET",
        headers: headers
    };

    /*return fetch(graphConfig.graphMeEndpoint, options)
        .then(response => response.json())
        .catch(error => console.log(error));*/

    /* //The /photo/$value endpoint returns the image in binary format (blob)
    return fetch(`${graphConfig.graphMeEndpoint}/photo/$value`, options)
        .then(response => {
            if (!response.ok) {
                throw new Error("Could not fetch profile photo.");
            }
            return response.blob();  // Convert to blob for image rendering
        })
        .catch(error => console.log(error));*/
    
    // Fetch user profile data
    const userResponse = await fetch("https://graph.microsoft.com/v1.0/me", options);
    console.log("userResponse2", userResponse,options);
    const userData = await userResponse.json();

    // Fetch user profile photo
    let photoUrl = "";
    try {
        const photoResponse = await fetch("https://graph.microsoft.com/v1.0/me/photo/$value", options);
        const photoBlob = await photoResponse.blob();
        photoUrl = URL.createObjectURL(photoBlob);
    } catch (error) {
        console.error("Error fetching user photo: ", error);
    }

    return {
        displayName: userData.displayName,
        photo: photoUrl,
        ...userData
    };
}


export async function callUsers(accessToken) {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options = {
        method: "GET",
        headers: headers
    };
    const userResponse = await fetch("https://graph.microsoft.com/v1.0/users", options);
    console.log("userResponse", userResponse,options);
    const userData = await userResponse.json();

  

    return {
        userData: userData,
    };
}
